// constants/index.js
export function getSidebarEntries(t) {
  return [
    {
      link: "/dashboard-statistiques",
      text: "Tableau de bord",

      // icon: () => iconGetter("abonnements"),
    },
    {
      link: "/users",
      text: "Liste Des Utilisateurs",

      // icon: () => iconGetter("abonnements"),
    },
    {
      link: "/clientsDevisList",
      text: "Liste Des Devis",
      // icon: () => iconGetter("abonnements"),
    },

    {
      link: "/Dashboard",
      text: "Dashboard",
      // icon: () => iconGetter("dashboard"),
    },

    {
      link: "/devis",
      text: "Devis",
      // icon: () => iconGetter("dashboard"),
    },

    // {
    //   link: "#",
    //   text: "listeFormations",
    //   // icon: () => iconGetter("formations"),
    //   subItems: [
    //     {
    //       link: "/formations",
    //       text: "toutesFormations",
    //     },
    //     {
    //       link: "/mesFormation",
    //       text: "mesFormations",
    //     },
    //   ],
    // },
    {
      link: "/visitors-list",
      text: "Liste Des Demandes",
    },
    {
      link: "/parametres",
      text: "Paramètres",
      // icon: () => iconGetter("abonnements"),
    },
          {
      link: "/config",
      text: "Configurations",
      // icon: () => iconGetter("abonnements"),
    }, {
      link: "/simulation",
      text: "Simulations",
      // icon: () => iconGetter("abonnements"),
    },    
            {
      link: "/contact",
      text: "Contacts",
      // icon: () => iconGetter("abonnements"),
    },
        {
      link: "/Form",
      text: "Contacts Consultek",
      // icon: () => iconGetter("dashboard"),
    },


    // {
    //   link: "/news",
    //   text: "news"),
    //   icon: () => iconGetter("news"),
    // },
    // {
    //   link: "/account",
    //   text: "account"),
    //   icon: () => iconGetter("account"),
    // },
  ];
}
